"use client";

import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { usePageTitle } from "@/lib/usePageTitle";

const lastUpdated = "January 19, 2026";

export default function TermsOfServicePage() {
  usePageTitle("Terms of Service");
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Navbar />
      <main className="flex-1 px-4 py-12 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl space-y-6">
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tight">Terms of service</h1>
            <p className="text-sm text-muted-foreground">Last updated: {lastUpdated}</p>
          </div>
          <div className="space-y-4 text-muted-foreground">
            <p>
              These Terms of Service govern your use of BlockyNetworks, a community platform operated by Favela Tech LLC.
              By accessing or using BlockyNetworks, you agree to these terms.
            </p>
            <p>
              BlockyNetworks provides tools to create organizations, list servers, and communicate with other players. You
              agree to use the platform responsibly and in compliance with applicable laws and community standards.
            </p>
            <p>
              You are responsible for the content you post and the servers you list. We may remove content or suspend
              accounts that violate our rules, infringe rights, or harm the community.
            </p>
            <p>
              All features are provided &quot;as is&quot; without warranties of any kind. To the fullest extent permitted by law,
              Favela Tech LLC disclaims all warranties and limits liability for indirect or consequential damages.
            </p>
            <p>
              We may update these terms from time to time. Continued use of the platform means you accept the updated
              terms.
            </p>
            <p>
              For questions about these terms, contact support@blockynetworks.com.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
